import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./Resources.da.resx"
import { R as _kl } from "./Resources.kl.resx"

type Translations = {
	"Name1": string,
	"Bitmap1": string,
	"Icon1": string,
	"ErrorCreateConsultation": string,
	"ErrorSendMessage": string,
	"Today": string,
	"ErrorFieldIsMandatory": string,
	"ConversationInProgress": string,
	"IsEmployee": string,
	"ConversationStartedInfo": string,
	"ErrorInvalidEmail": string,
	"ErrorInvalidCpr": string,
	"Tomorrow": string,
	"ErrorEmailAndOrPhone": string,
	"ErrorUnknown": string,
	"NameMustBeFilled": string,
	"NameMustOnlyContainLetters": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "kl" || (!process.env.enforcedLocale && getLocale("da") === "kl")) {
			return _kl[name] ?? name
		}

		return name
	},
}) as Translations

export { R }